<ng-select [items]="options$ | async" [placeholder]="to.placeholder" [typeahead]="searchInput$" bindLabel="displayText"
    [formControl]="formControl" [loading]="showLoader">
    <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
        <div><span>{{item.displayText}}</span></div>
    </ng-template>
</ng-select>